import { useDispatch } from 'react-redux';
import { useContext } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useStartSectionsLibraryOnboardingTour } from 'ContentEditorUI/hooks/useStartSectionsLibraryOnboardingTour';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import { SECTIONS_LIBRARY_TOUR } from 'ContentEditorUI/constants/tours';
import { Text } from 'foundations-components/components/Text';
// @ts-expect-error Untyped module
import { HAS_SEEN_SECTIONS_LIBRARY_ONBOARDING_TOUR } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
// @ts-expect-error Untyped module
import { setSuperstoreUserSetting } from 'ContentEditorUI/redux/actions/settingsActions';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledButton = props => /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
  use: "link"
}));
const SectionsLibraryOnboardingTourStep = () => {
  const {
    tour
  } = useContext(TourContext);
  return /*#__PURE__*/_jsx(UITourStep, {
    stepKey: "addSection",
    tourKey: SECTIONS_LIBRARY_TOUR,
    showCloseButton: true,
    attachTo: "#contentEditor-preview",
    content: {
      header: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sectionsLibraryOnboardingTour.step.header"
        })
      }),
      body: /*#__PURE__*/_jsx(Text, {
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sectionsLibraryOnboardingTour.step.body"
        })
      }),
      footer: /*#__PURE__*/_jsx(Text, {
        as: "strong",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sectionsLibraryOnboardingTour.step.actionText"
        })
      })
    },
    pulser: {
      attachTo: '#contentEditor-preview'
    },
    onClickCloseButton: () => {
      tour.finish();
    }
  });
};
const SectionsLibraryInfoBanner = () => {
  const dispatch = useDispatch();
  const {
    startTour
  } = useStartSectionsLibraryOnboardingTour();
  const handleCloseBanner = () => {
    dispatch(setSuperstoreUserSetting(HAS_SEEN_SECTIONS_LIBRARY_ONBOARDING_TOUR, Date.now()));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SectionsLibraryOnboardingTourStep, {}), /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "components.sidebar.sectionsLibraryInfoBanner.title"
        }), /*#__PURE__*/_jsx(Badge, {
          use: "beta",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "components.sidebar.sectionsLibraryInfoBanner.betaBadge"
          })
        })]
      }),
      type: "tip",
      margin: "300",
      closeable: true,
      onClose: handleCloseBanner,
      "data-test-id": "sections-library-info-banner",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "components.sidebar.sectionsLibraryInfoBanner.message_jsx",
        options: {
          onClick: startTour
        },
        elements: {
          Button: StyledButton
        }
      })
    })]
  });
};
export default SectionsLibraryInfoBanner;